import React from 'react';
import { flex } from '@fabric-ui/theme';
import { abbreviateNumber } from '@fabric-ui/utils';
import { Box, useTheme } from '@mui/material';
import { AvTooltip } from '../AvTooltip';
import { useAvContext } from '../context/FabricProvider';
import { ingressProjIcons, uberProjIcons } from '../projIcons';

interface Props {
  projName: string;
  total: number;
  includeIngressProj?: boolean;
  includeProjName?: boolean;
  tooltipText?: boolean;
}

export const avProjIconTagContainerStyle = {
  pr: 0.5,
  gap: 1,
  fontSize: 12,
  borderRadius: 1.5,
  color: theme => theme.palette.colors.neutrals[700],
  ...flex.itemsCenter,
  height: 20,
  fontWeight: '400',
  background: theme => theme.palette.colors.neutrals[150],
};
export const avProjTagInnerStyle = {
  borderRadius: 1.5,
  color: theme => theme.palette.colors.neutrals[650],
  background: theme => theme.palette.colors.neutrals[350],
  ...flex.itemsCenter,
  padding: 0.15,
  fontWeight: 600,
  svg: { height: 14, width: 14 },
};
export const AvProjIconTag: React.FC<Props> = ({ projName, total, includeIngressProj, includeProjName, tooltipText = false }) => {
  const {
    accountEntities: { aggProjs },
  } = useAvContext();
  const theme = useTheme();
  const allProjIcon = { ...uberProjIcons(theme), ...(includeIngressProj ? ingressProjIcons(theme) : {}) };
  const projIcon = allProjIcon[projName] ?? allProjIcon.default;
  const { projDisplayName } = aggProjs[projName];
  return (
    <AvTooltip title={projDisplayName} disabled={!tooltipText}>
      <Box key={projName} sx={avProjIconTagContainerStyle}>
        <Box sx={avProjTagInnerStyle}>{projIcon.icon}</Box>
        {includeProjName && projDisplayName}
        <Box sx={{ pr: 0.25, ...(includeProjName && { fontWeight: 'bold' }) }}>{abbreviateNumber(total || 0)}</Box>
      </Box>
    </AvTooltip>
  );
};
